// ABOUTME: Content of a product card in the treeview catalog: a row with image, name, starting price and actions.
// ABOUTME: Fills the model-selection product card's OverrideContent slot; the card click opens the configurator.

import { SettingsOutlinedIcon, Stack, Typography } from '@ds/coolshop';
import { useIntl } from 'react-intl';

import { CatalogThumbnail } from './CatalogThumbnail';
import { getProductImageUrl } from './getProductImageUrl';
import { ProductCardContentProps } from './ProductCardContent';
import { ProductCardStartActions } from './ProductCardStartActions';

// Side of the product image, as in the catalog visuals.
const THUMBNAIL_SIZE = '48px';

/**
 * The starting price shows only when the model carries one: the catalog sends 0 for a model whose
 * price is not set or is hidden.
 */
export function CatalogProductRowContent({
    modelNameHighlighted,
    showFavorite,
    ...product
}: ProductCardContentProps) {
    const { formatMessage, formatNumber } = useIntl();
    const { listPrice, currency } = product;
    const price =
        listPrice && listPrice > 0 && currency
            ? formatNumber(listPrice, { style: 'currency', currency })
            : undefined;

    return (
        <Stack direction="row" alignItems="center" gap={2} data-testid="catalog-product-row">
            <CatalogThumbnail
                url={getProductImageUrl(product)}
                alt={product.description}
                size={THUMBNAIL_SIZE}
            />
            <Stack flex={1} minWidth={0}>
                <Typography variant="subtitle2">
                    {modelNameHighlighted ?? product.description}
                </Typography>
                {price && (
                    <Typography variant="caption" color="text.secondary">
                        {formatMessage(
                            {
                                id: 'cpq.catalog.startingPrice',
                                defaultMessage: 'Starting price {price}',
                            },
                            { price },
                        )}
                    </Typography>
                )}
            </Stack>
            <ProductCardStartActions {...product} showFavorite={showFavorite} />
            {/* The whole card opens the configurator: the gear only says so. */}
            <SettingsOutlinedIcon color="secondary" aria-hidden />
        </Stack>
    );
}
